import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        // {
        //     path: '/',
        //     name: '/notice',
        //     component(resolve) {
        //         require.ensure(['../views/notice.vue'], () => {
        //             resolve(require('../views/notice.vue'));
        //         });
        //     },
        // },
        {
            path: '/',
            // path: '/home',
            name: '/master',
            component(resolve) {
                require.ensure(['../views/master.vue'], () => {
                    resolve(require('../views/master.vue'));
                });
            },
            children: [
                {
                    path: '/',
                    name: '/recharge',
                    component(resolve) {
                        require.ensure(['../views/recharge.vue'], () => {
                            resolve(require('../views/recharge.vue'));
                        });
                    },
                },
                {
                    path: '/pointsshop',
                    name: '/pointsshop',
                    component(resolve) {
                        require.ensure(['../views/pointsshop.vue'], () => {
                            resolve(require('../views/pointsshop.vue'));
                        });
                    },
                },
                {
                    path: '/order',
                    name: '/order',
                    component(resolve) {
                        require.ensure(['../views/order.vue'], () => {
                            resolve(require('../views/order.vue'));
                        });
                    },
                },
                {
                    path: '/recharge',
                    name: '/recharge',
                    component(resolve) {
                        require.ensure(['../views/recharge.vue'], () => {
                            resolve(require('../views/recharge.vue'));
                        });
                    },
                },
                {
                    path: '/recharge_detail',
                    name: '/recharge_detail',
                    component(resolve) {
                        require.ensure(['../views/recharge_detail.vue'], () => {
                            resolve(require('../views/recharge_detail.vue'));
                        });
                    },
                }
            ]
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js